import { EMPTY_OBJECT } from '../../../constants/common'
import { ProfileAISummaryWidgetArrowIcon } from '../ProfileAISummaryWidgetArrowIcon'
import { WidgetHeaderContentActionsExpandButton } from '../WidgetHeaderContentActionsExpandButton'

import * as styles from './ProfileAISummaryWidgetHeaderActions.module.css'

function ProfileAISummaryWidgetHeaderActions({
  className = styles.ProfileAISummaryWidgetHeaderActions,
  expandButtonProps: {
    ArrowIcon: ExpandButtonArrowIcon = ProfileAISummaryWidgetArrowIcon,
    className: expandButtonClassName = styles.expandButton,
    ...expandButtonProps
  } = EMPTY_OBJECT,
}) {
  return (
    <div className={className}>
      <WidgetHeaderContentActionsExpandButton
        {...expandButtonProps}
        ArrowIcon={ExpandButtonArrowIcon}
        className={expandButtonClassName}
      />
    </div>
  )
}

export default ProfileAISummaryWidgetHeaderActions
